import { useState } from "react";
import { apiURL } from "../../consts/URLs";
import { CLIENTS } from "../endpointList";
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const token = getCookie(cookieName.token);

const useClient = () => {
  const [createResponse, setCreateResponse] = useState<any>();
  const [createResult, setCreateResult] = useState<any>();
  const [updateResponse, setUpdateResponse] = useState<any>();
  const [updateResult, setUpdateResult] = useState<any>();
  const [deleteResponse, setDeleteResponse] = useState<any>();
  const [deleteResult, setDeleteResult] = useState<any>();

  const [getByIdResponse, setGetByIdResponse] = useState<any>();
  const [getByIdResult, setGetByIdResult] = useState<any>();

  const [getListPaginatedResponse, setGetListPaginatedResponse] =
    useState<any>();
  const [getListPaginatedResult, setGetListPaginatedResult] = useState<any>();
  const [getListAllResponse, setGetListAllResponse] = useState<any>();
  const [getListAllResult, setGetListAllResult] = useState<any>();

  const createClient = (obj: any) => {
    const url = `${apiURL}/${CLIENTS}`;
    const options = getOptions({
      method: "POST",
      body: { ...obj },
      token: token,
    });
    fetchRequest(url, options, setCreateResponse, setCreateResult);
  };

  const updateClient = (id: number, obj: any) => {
    const url = `${apiURL}/${CLIENTS}/${id}`;
    const options = getOptions({
      method: "PUT",
      body: { ...obj },
      token: token,
    });
    fetchRequest(url, options, setUpdateResponse, setUpdateResult);
  };

  const deleteClient = (id: number) => {
    const url = `${apiURL}/${CLIENTS}/${id}`;
    const options = getOptions({ method: "DELETE", token: token });
    fetchRequest(url, options, setDeleteResponse, setDeleteResult);
  };

  const getClientById = (id: number) => {
    const url = `${apiURL}/${CLIENTS}/${id}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(url, options, setGetByIdResponse, setGetByIdResult);
  };

  const getListPaginated = () => {
    const url = `${apiURL}/${CLIENTS}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(
      url,
      options,
      setGetListPaginatedResponse,
      setGetListPaginatedResult
    );
  };

  const getListAll = () => {
    const url = `${apiURL}/${CLIENTS}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(url, options, setGetListAllResponse, setGetListAllResult);
  };

  const RESPONSES = {
    getListAllResponse,
    createResponse,
    updateResponse,
    deleteResponse,
    getListPaginatedResponse,
    getByIdResponse,
  };

  const RESULTS = {
    getListAllResult,
    createResult,
    updateResult,
    deleteResult,
    getListPaginatedResult,
    getByIdResult,
  };

  const CTAs = {
    getListAll,
    createClient,
    updateClient,
    deleteClient,
    getListPaginated,
    getClientById,
  };

  return { RESPONSES, RESULTS, CTAs };
};
export default useClient;
